import { getActiveSeason, SEASON_HALLOWEEN } from "../../utils/season";
import styles from "./ButtonSpider.module.scss";
import { PixelGhost, PixelPumpkin, PixelSpider } from "./pixelSprites";

export default function ButtonSpider({ kind = "spider" }) {
  if (getActiveSeason() !== SEASON_HALLOWEEN) return null;

  return (
    <span className={`${styles.perch} ${styles[kind]}`} aria-hidden="true">
      {kind === "spider" && <span className={styles.silk} />}
      {kind === "spider" && <PixelSpider className={styles.spider} />}
      {kind === "ghost" && <PixelGhost className={styles.ghost} />}
      {kind === "pumpkin" && <PixelPumpkin className={styles.pumpkin} />}
    </span>
  );
}
